import { Button } from '../../../ui';

const Hero = () => {
  const handleScroll = key => {
    const section = document.getElementById(key);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="bg-white relative">
      <img src="/images/worldCup/bg.jpg" alt="Background" className="absolute z-10 w-full h-full object-cover md:object-left object-right" />
      <div className="container relative z-20 md:pt-[110px] pt-[123px] pb-[24px]">
        <div className="flex flex-col  gap-[84px]">
          <div className="flex flex-col md:gap-[31px] gap-[24px] justify-center max-w-[446px] w-full md:pb-0 pb-[16px]">
            <h1 className="font-[700] md:text-[40px] text-[36px]  md:leading-[53px] leading-[44px] text-white uppercase">
              Dominate <br /> World cup 2026 Advertising Before competitors do
            </h1>
            <div className="flex gap-[16px] flex-col md:flex-row">
              <div className="flex md:w-[216px] w-full items-center justify-center">
                <Button variant="lightGreenOffer" className="md:w-[216px] w-full hover:md:w-[206px]" onClick={() => handleScroll('packages')}>
                  View packages
                </Button>
              </div>
              <div className="flex md:w-[216px] w-full items-center justify-center">
                <Button variant="whiteOffer" className="md:w-[216px] w-full hover:md:w-[206px]" onClick={() => handleScroll('black-offer')}>
                  Request KPI forecast
                </Button>
              </div>
            </div>
          </div>
          <div className="hide_scrollbar flex flex-row flex-nowrap overflow-auto items-center justify-between gap-[8px]">
            <div className="flex flex-row items-center gap-[8px] flex-nowrap">
              <div className="w-[8px] h-[8px] rounded-full bg-[#d5dd23]"></div>
              <p className="text-white text-[12px] font-thin whitespace-nowrap">Telegram Advertising Network</p>
            </div>
            <div className="flex flex-row items-center gap-[8px]">
              <div className="w-[8px] h-[8px] rounded-full bg-[#FAC8A5]"></div>
              <p className="text-white text-[12px] font-thin whitespace-nowrap">Cinema Network (Movie Site Ads)</p>
            </div>
            <div className="flex flex-row items-center gap-[8px]">
              <div className="w-[8px] h-[8px] rounded-full bg-[#CFBA99]"></div>
              <p className="text-white text-[12px] font-thin whitespace-nowrap">Sport Ads Network</p>
            </div>
            <div className="flex flex-row items-center gap-[8px]">
              <div className="w-[8px] h-[8px] rounded-full bg-[#D5DD23]"></div>
              <p className="text-white text-[12px] font-thin whitespace-nowrap">PPC (Search + Social)</p>
            </div>
            <div className="flex flex-row items-center gap-[8px]">
              <div className="w-[8px] h-[8px] rounded-full bg-[#EDEEB2EE]"></div>
              <p className="text-white text-[12px] font-thin whitespace-nowrap">SEO Articles & Placements</p>
            </div>
            <div className="flex flex-row items-center gap-[8px]">
              <div className="w-[8px] h-[8px] rounded-full bg-[#D8E0D3]"></div>
              <p className="text-white text-[12px] font-thin whitespace-nowrap">Social Media Management </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
